import { useState } from 'react';

const heroImages = [
  '/assets/hero/hero-1.jpg',
  '/assets/hero/hero-2.jpg',
  '/assets/hero/hero-3.jpg',
  '/assets/hero/hero-4.jpg',
];

const stats = [
  { value: '10', label: 'Casas Exclusivas' },
  { value: '+7',  label: 'Años de Experiencia' },
  { value: '$155K', label: 'Precio de venta' },
];

export default function Hero() {
  const [heroImg] = useState(() => heroImages[Math.floor(Math.random() * heroImages.length)]);

  return (
    <section className="grid md:grid-cols-2 lg:grid-cols-[43%_57%] xl:grid-cols-[40%_60%] 2xl:grid-cols-[37%_63%]" style={{ minHeight: 'calc(100dvh - 68px)' }}>
      {/* Left */}
      <div className="flex flex-col justify-between px-8 md:px-16" style={{ paddingTop: 'clamp(1rem, 4.5vh, 3.5rem)', paddingBottom: 'clamp(1rem, 4.5vh, 3rem)' }}>
        {/* Eyebrow */}
        <div className="flex items-center gap-2">
          <span className="w-5 h-px bg-gray-300" />
          <span className="text-xs tracking-[.28em] text-gray-400 uppercase font-medium whitespace-nowrap">Condominio Resort · Preventa</span>
        </div>

        {/* Headline */}
        <div className="flex-1 flex flex-col justify-center" style={{ paddingTop: 'clamp(0.5rem, 3vh, 2.5rem)', paddingBottom: 'clamp(0.5rem, 3vh, 2.5rem)' }}>
          <h1 className="text-[clamp(2.8rem,5vw,4rem)] font-bold leading-[1.05] text-black mb-6">
            El Alto de<br/>
            <span className="font-light italic">los Bosques</span>
          </h1>
          <p className="text-gray-500 text-lg leading-relaxed mb-8 max-w-[420px] font-light">
            Tu paraíso privado en Baños del Inca, Cajamarca. Casas de campo de lujo con comodidades exclusivas y alta plusvalía en una de las maravillas del Perú.
          </p>

          <button
            className="group flex items-center gap-3 bg-black text-white text-sm font-medium
              px-5 py-3 rounded-full w-fit transition-all duration-300
              hover:bg-black/80 hover:shadow-lg hover:-translate-y-0.5 active:scale-95"
          >
            Solicita Información
            <span className="w-6 h-6 bg-white rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:rotate-45">
              <svg className="w-3 h-3 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17L17 7M17 7H7M17 7v10" />
              </svg>
            </span>
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 md:flex md:gap-8 pt-6 md:pt-8 border-t border-gray-100">
          {stats.map((s, i) => (
            <div key={s.label}>
              {i > 0 && <span className="hidden" />}
              <p className="text-xl md:text-2xl font-bold text-black">{s.value}</p>
              <p className="text-xs text-gray-400 mt-0.5">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Right — image */}
      <div className="relative h-80 md:h-auto overflow-hidden">
        <img
          src={heroImg}
          alt="El Alto de los Bosques"
          className="absolute inset-0 w-full h-full object-cover md:rounded-tl-[2rem]"
        />
        {/* Location badge */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-6 w-max bg-white/90 backdrop-blur-sm rounded-2xl px-4 py-2.5 flex items-center gap-2 shadow-lg">
          <div className="w-1.5 h-1.5 rounded-full bg-amber-500" />
          <span className="text-xs font-medium text-gray-700">Baños del Inca · Cajamarca · Perú</span>
        </div>
      </div>
    </section>
  );
}
